import Client from '@abroad/rest-client/lib/Client'

const API = new Client({
  baseUrl: process.env.REACT_APP_API_ENDPOINT,
})

export default API
